import moment from 'moment'

import ClickableIcon from '@/components/ClickableIcon'
import { Delete, Edit2 } from '@/components/Icons'
import { getDisplayName } from '@/utilities/UserUtilities'

import messages from './messages'

export default ({ intl, navigateToEditUser, showConfirmDelete }: any) => [
  {
    property: 'name.familyName',
    header: {
      label: intl.formatMessage(messages.name),
      sortable: true
    },
    cell: {
      formatters: [
        (id: any, { rowData }: any) => (
          <>
            <span className="keyvalues__label">{getDisplayName(rowData)}</span>
            <span className="name-email sub-text">{rowData.email}</span>
          </>
        )
      ]
    }
  },
  {
    property: 'email',
    header: {
      label: intl.formatMessage(messages.email)
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="sub-text">{rowData.email}</span>]
    }
  },
  {
    property: 'meta.created',
    header: {
      label: intl.formatMessage(messages.dateAdded),
      sortable: true
    },
    cell: {
      formatters: [
        (id: any, { rowData }: any) => <span className="sub-text">{moment(rowData.createdAt).fromNow()}</span>
      ]
    }
  },
  {
    property: 'isOrgAdmin',
    header: {
      label: intl.formatMessage(messages.admin)
    },
    cell: {
      formatters: [
        (isOrgAdmin: any) => (
          <span className="sub-text">
            {isOrgAdmin ? intl.formatMessage(messages.yes) : intl.formatMessage(messages.no)}
          </span>
        )
      ]
    }
  },
  {
    property: 'id',
    cell: {
      props: {
        style: {
          width: 50
        }
      },
      // TODO Remove this onClick and wrap it in a button
      formatters: [(id: any) => <ClickableIcon callback={navigateToEditUser} parameter={id} render={Edit2} />]
    }
  },
  {
    property: 'id',
    cell: {
      props: {
        style: {
          width: 50
        }
      },
      // TODO Remove this onClick and wrap it in a button
      formatters: [(id: any) => <ClickableIcon callback={showConfirmDelete} parameter={id} render={Delete} />]
    }
  }
]
